import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { ApiService } from 'src/app/core/api.service';
import { Lesson } from 'src/app/core/models/lesson';
import FlvPlayer from 'flv.js';

@Component({
  selector: 'app-keylesson-detail',
  templateUrl: './keylesson-detail.component.html',
  styleUrls: ['./keylesson-detail.component.scss']
})
export class KeylessonDetailComponent implements OnInit {

  lesson: Lesson;
  player: any;

  playMode: boolean;

  @ViewChild('target', {static: true}) container: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private authService: AuthService) { }

  ngOnInit() {

    // resolver data
    this.route.data
      .subscribe((value: {lesson: Lesson}) => {
        this.lesson = value.lesson;

        console.log(this.lesson)
        // load extra needed data
        //this.loadLessonData() //moved to resolver
      });       
  }


  private loadLessonData() {
    const { userid, language_in_use } = this.authService.user$.value;

    const requests = [
      this.apiService.loadLessonsExercises(userid, this.lesson.id, language_in_use),
      this.apiService.loadExerciseVideos(userid, this.lesson.id, language_in_use)
    ];
    
    forkJoin([...requests])
      .subscribe((values: any[]) => {
        // exercises list
        const exercisesResult = values[0]
        const exercises: string[] = exercisesResult.lesson.ex;
        this.lesson.exercises = exercises;

        // exercises list
        const videosResult = values[1]
        let videos: string[] = videosResult.lesson.ex;
        videos = videos.map((value: string) => value.replace('Flv', 'MP4'))
        videos = videos.map((value: string) => value.replace('flv', 'mp4'))
        
        videos.map((value, index) => this.lesson.videos.set(index + 1, value));
        
      })   
  }

  continue() {
    this.router.navigate(['player', {continue: true}], {relativeTo: this.route});
  }

  reset() {
    this.router.navigate(['player'], {relativeTo: this.route});
  }

  onDeactivateChild(){
    this.playMode=false;
    //this.router.navigate(['/keylesson']);
  }

  goBack() {
    this.router.navigate(['/keylesson']);
  }

  get lessonLetters(): string {
    if(!this.lesson.exercises.length) { return '-'}
    return this.lesson.letters.join(' ');
  }

  get lessonVideoUrl(): string {

    const {language_in_use} = this.authService.user$.value;
    
    //return 'assets/videos/Lesson 1.mp4';
    return `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/Lesson ${this.lesson.id}.mp4`;
  }

}
